// @flow
import React from "react";
import {useObserver} from "mobx-react-lite";
import {Form, Modal, Upload} from "antd";
import {useTranslation} from "react-i18next";
import {UploadIcon} from "../../../../_defaultComponents/CourierFileUploadModal/CfuStyles";
import {message} from "antd";

export const UploadInvoiceModal = ({visibility, onCancel, setFieldValue}) => {
    const {t} = useTranslation(["uploadInvoiceModal"]);

    const {Dragger} = Upload;

    const props = {
        beforeUpload(file) {
            return new Promise(resolve => {
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                    message.error("Dosya boyutu 10 MB' dan büyük olamaz. Kontrol ediniz!");
                    return Promise.reject();
                }
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    const base64String = reader.result.split(",")[1];
                    const payload = {
                        originalname: file.name,
                        mimetype: file.type,
                        buffer: base64String
                    };
                    resolve(payload);
                    setFieldValue("transactionPhoto", payload);
                    onCancel();
                };
                reader.onerror = error => reject(error);
            });
        }
    };

    return useObserver(() => (
        <React.Fragment>
            <Modal
                visible={visibility}
                centered
                title={"Fatura Yükle"}
                okText={"Tamam"}
                onOk={onCancel}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
                data-testid="uploadInvoiceModal"
                onCancel={onCancel}
                cancelButtonProps={{
                    "data-testid": "uploadInvoiceModal_cancelButton"
                }}
            >
                <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                    <Form.Item
                        label={"Fatura Ekle  (10 MB' a kadar dosya yükleyebilirsiniz)"}
                        data-testid="fileDraggerContainer"
                    >
                        <Dragger
                            {...props}
                            data-testid="fileDragger"
                            accept=".png,.jpg,.jpeg,.heic,.hevc,.pdf"
                        >
                            <UploadIcon />
                        </Dragger>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    ));
};
